import { render, staticRenderFns } from "./RealtorStep.vue?vue&type=template&id=f0bc0f8a&"
import script from "./RealtorStep.vue?vue&type=script&lang=js&"
export * from "./RealtorStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports